import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import { ProductDetail } from "../types";
import { useTranslation } from "../../../../hooks/useTranslation";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { useGetLocale } from "@refinedev/core";
import { Section } from "./Section";
type USStoreProps = {
  productDetail?: ProductDetail;
};

const StatusIcon = ({ status }: { status?: boolean }) => {
  return status ? (
    <CheckCircle fontSize="small" sx={{ color: "green" }} />
  ) : (
    <Cancel fontSize="small" sx={{ color: "red" }} />
  );
};

const formatDate = (
  date: string | undefined,
  locale: string | undefined,
  translateWithoutPrefix: (_key: string) => string,
) => {
  return date
    ? new Date(date).toLocaleString(locale)
    : translateWithoutPrefix("common.unknown");
};

export const USStore = ({ productDetail }: USStoreProps) => {
  const { translate, translateWithoutPrefix } = useTranslation("pages.product");
  const locale = useGetLocale();

  const getProductStatus = () => {
    const status = productDetail?.marketplaceProduct?.product?.productStatus;

    const translatableStatuses: Record<string, string> = {
      CREATED: "CREATED",
      LISTED_IN_US: "LISTED_IN_US",
      NOT_LISTED_IN_US: "NOT_LISTED_IN_US",
    };

    return status && translatableStatuses[status]
      ? translate("status." + translatableStatuses[status])
      : translateWithoutPrefix("common.unknown");
  };

  return (
    <Section title={translate("USStore")}>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>{translate("doesCargoDiscountKnown")}</TableCell>
            <TableCell>
              <StatusIcon
                status={
                  productDetail?.supplier?.deliveryCost != null &&
                  productDetail.supplier.deliveryCost > 0
                }
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("productStatus")}</TableCell>
            <TableCell>{getProductStatus()}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("discountedProduct")}</TableCell>
            <TableCell>
              <StatusIcon status={productDetail?.supplier?.hasDiscount} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("couponDiscountAvailable")}</TableCell>
            <TableCell>
              <StatusIcon status={productDetail?.supplier?.hasPromoDiscount} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("primeDiscountAvailable")}</TableCell>
            <TableCell>
              <StatusIcon status={productDetail?.supplier?.primeExclusive} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("lastInventoryUpdateDate")}</TableCell>
            <TableCell>
              {formatDate(
                productDetail?.supplier?.updated,
                locale(),
                translateWithoutPrefix,
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("lastProductUpdateDate")}</TableCell>
            <TableCell>
              {formatDate(
                productDetail?.updated,
                locale(),
                translateWithoutPrefix,
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{translate("creationDate")}</TableCell>
            <TableCell>
              {formatDate(
                productDetail?.created,
                locale(),
                translateWithoutPrefix,
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Section>
  );
};
